<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- Navbar -->
  <nav
    navbar-main
    class="relative flex flex-wrap items-center justify-between px-0 py-2 mx-6 transition-all ease-in shadow-none duration-250 rounded-2xl lg:flex-nowrap lg:justify-start"
    navbar-scroll="false"
  >
    <div class="flex items-center justify-between w-full sm:px-4 py-1 mx-auto flex-wrap-inherit">
      <nav class="hidden sm:block">
        <div class="text-xxs font-bold text-gray-700 dark:text-gray-300 capitalize">v 1.5.0</div>
        <!-- Breadcrumb -->
        <ol class="flex flex-wrap pt-1 ml-8 bg-transparent rounded-lg sm:ml-12">
          <li class="pr-0 text-sm leading-normal">
            <a class="text-gray-600 dark:text-gray-400 opacity-50" href="javascript:;">
              شركة المنارة المتقدمة
            </a>
          </li>
        </ol>
        <h6 class="mb-0 font-bold text-gray-700 dark:text-gray-200 capitalize">حلقات جامع الراجحي</h6>
      </nav>

      <div class="relative flex items-center -ml-8" v-auto-animate>
        <!-- Sidebar toggle button for larger screens -->

        <span
          v-if="!globalStore.isToggled"
          @click="globalStore.toggleSidebar()"
          class="cursor-pointer absolute text-gray-700 dark:text-gray-200"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="h-8 w-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </span>

        <span v-else @click="globalStore.toggleSidebar()" class="cursor-pointer absolute">
          <div class="w-4.5 overflow-hidden">
            <i
              class="ease mb-0.75 relative block h-0.5 -translate-x-[5px] rounded-sm bg-gray-600 transition-all dark:bg-white"
            ></i>
            <i
              class="ease mb-0.75 relative block h-0.5 rounded-sm bg-gray-600 transition-all dark:bg-white"
            ></i>
            <i
              class="ease relative block h-0.5 -translate-x-[5px] rounded-sm bg-gray-600 transition-all dark:bg-white"
            ></i>
          </div>
        </span>
      </div>

      <div
        class="flex items-center mt-2 grow sm:mt-0 sm:ml-6 md:ml-0 lg:flex lg:basis-auto"
        id="navbar"
      >
        <div class="flex items-center md:mr-auto md:pl-4"></div>
        <ul class="flex flex-row justify-end pr-0 mb-0 list-none md-max:w-full gap-4">
          <li class="flex items-center">
            <button
              @click="toggleDark()"
              class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-gray-700 dark:text-gray-200"
              aria-label="Toggle dark mode"
            >
              <svg
                v-if="isDark"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
                />
              </svg>
            </button>
          </li>
          <li class="flex items-center">
            <DropdownMenu :name="user?.name as string" />
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script setup lang="ts">
import { UserModel } from '@/models/user'
import DropdownMenu from '../components/DropdownMenu.vue'
import { ref } from 'vue'
import { useGlobalStore } from '@/stores/global'
import { useDark, useToggle } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { auth } from '@/stores/auth'

// const username = ref(new UserModel().fromJson(localStorage.user).name)
const { user } = storeToRefs(auth())
const globalStore = useGlobalStore()

const isDark = useDark()
const toggleDark = useToggle(isDark)
</script>
